export default "__VITE_ASSET__CpsNWFLC__"